import { render, staticRenderFns } from "./PowerPerformanceChart.vue?vue&type=template&id=2bd44288&scoped=true&"
import script from "./PowerPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./PowerPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./PowerPerformanceChart.vue?vue&type=style&index=0&id=2bd44288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd44288",
  null
  
)

export default component.exports